import { render, staticRenderFns } from "./OrgPreview.vue?vue&type=template&id=5fc935e2&"
import script from "./OrgPreview.vue?vue&type=script&lang=js&"
export * from "./OrgPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports